import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as SearchMagnifyIcon } from '../../assets/svg/SearchMagnifyIcon.svg';
import Loading from '../Loading';
import FilterCourses from '../courses/FilterCourses';
import { deleteQuickTipStudentById, getQuickTipsStudent, getSolutionCategories } from '../../server/server';
import CreateEditTipModal from './CreateEditTipModal';
import { ReactComponent as DeleteIcon } from '../../assets/svg/DeleteIcon.svg';
import InfiniteScroll from 'react-infinite-scroll-component';
import ConfirmationModal from '../modals/ConfirmationModal';
import { notify } from '../../utils/util';
import MDEditor from '@uiw/react-md-editor';

function QuickTipsHome() {
	const navigate = useNavigate();
	const [currentPath, setCurrentPath] = useState(window.location.pathname);
	const [isParent, setIsParent] = useState(window.location.pathname.includes('parent'));
	const [tips, setTips] = useState<any[]>([]);
	const [loading, setLoading] = useState(false);
	const [loadingCategories, setLoadingCategories] = useState(true);
	const [searchTerm, setSearchTerm] = useState('');
	const [filterState, setFilterState] = useState('');
	const [createTipModal, setCreateTipModal] = useState(false);
	const [selectedTip, setSelectedTip] = useState<any | null>(null);
	const [categories, setCategories] = useState<any>([]);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [practiceForDelete, setPracticeForDelete] = useState('');
	const [search, setSearch] = useState('');
	const [loadingMore, setLoadingMore] = useState(false);
	const timeout = useRef<any>(null);
	const [resultsNum, setResultsNum] = useState(0);
	const [hasMore, setHasMore] = useState(true);
	const isFirstMount = useRef(true);

	useEffect(() => {
		handleUrlChange();
	}, [window.location.pathname]);

	useEffect(() => {
		if (isFirstMount.current) {
			isFirstMount.current = false;
			return;
		}
		if (resultsNum === 0) loadTips();
		else setResultsNum(0);
	}, [filterState, currentPath]);

	useEffect(() => {
		loadTips();
	}, [resultsNum]);

	const loadTips = async (searchTerm: string = search) => {
		if (resultsNum === 0) setLoading(true);
		else setLoadingMore(true);
		const resp = await getQuickTipsStudent({ limit: 6, offset: resultsNum, term: searchTerm, category: filterState });
		if (resp.status == 200) {
			const data = resp.data?.data;
			const total = resp.data?.total;
			if (resultsNum === 0) {
				setTips(data);
				setHasMore(total > data?.length);
			} else {
				setHasMore(total > tips.length + data?.length);
				setTips((prev: any) => [...prev, ...data]);
			}

			setLoadingMore(false);
			setLoading(false);
		} else {
			setLoading(false);
		}
	};

	const handleUrlChange = () => {
		setCurrentPath(window.location.pathname);
		setIsParent(window.location.pathname.includes('parent'));
	};

	const handleChange = (e: any) => {
		e.preventDefault();
		setSearch(e.target.value);
		if (timeout !== null) {
			clearTimeout(timeout.current);
		}
		timeout.current = setTimeout(() => {
			if (resultsNum === 0) loadTips(e.target.value);
			else setResultsNum(0);
		}, 700);
	};

	// const loadCategories = async () => {
	// 	const resp = await getSolutionCategories();
	// 	if (resp.status === 200) {
	// 		setCategories([...resp.data]);
	// 		setLoadingCategories(false);
	// 	} else {
	// 		setLoadingCategories(false);
	// 	}
	// };

	const reloadTips = () => {
		if (resultsNum === 0) loadTips();
		else setResultsNum(0);
	};

	const deleteTip = async () => {
		const resp = await deleteQuickTipStudentById(practiceForDelete);
		if (resp.status === 200) {
			if (resultsNum === 0) loadTips();
			else setResultsNum(0);
			notify('The tip has been successfully deleted!');
		} else {
			notify('The tip has not been deleted!');
		}
	};

	const closeCreateTipModal = () => {
		setCreateTipModal(false);
		setSelectedTip(null);
	};
	const closeModal = () => {
		setModalIsOpen(false);
	};

	return (
		<div id='scroll-inf-task' className='flex h-screen flex-col items-center overflow-y-auto bg-[#ECEBF8] py-[40px]'>
			<div className=' w-full min-h-fit   max-w-[1200px] px-[10px]'>
				<div className='w-full min-h-[calc(100vh-80px)]  bg-white flex flex-col px-[40px] py-[30px] rounded-[10px]'>
					<div className='mb-[30px] flex flex-row  items-end gap-4'>
						<p className='flex-1 text-[40px] leading-[50px] font-bold text-darkViolet'>Quick tips</p>

						<div
							className={`cursor-pointer flex h-[50px]  min-w-[180px] px-3 items-center justify-center rounded-full border border-primaryViolet
                            bg-white text-[18px] leading-6  font-semibold text-primaryViolet transition  hover:bg-primaryViolet hover:text-brandYellow`}
							onClick={() => {
								setCreateTipModal(true);
							}}
						>
							Add new tip
						</div>
					</div>
					<div className=' flex w-full flex-row gap-5'>
						<div className='flex  h-[50px] flex-1 flex-row items-center rounded-full border border-primaryViolet  px-4'>
							<input type='text' placeholder='Search' value={search} onChange={(e: any) => handleChange(e)} className='h-full flex-1 rounded-full  outline-none  text-[18px] leading-6  font-semibold text-primaryViolet placeholder:font-medium placeholder:text-mudPurple' autoComplete='off' />
							<SearchMagnifyIcon />
						</div>
					</div>
					{!loadingCategories && <FilterCourses filterState={filterState} setFilterState={setFilterState} categories={categories} />}
					{tips.length === 0 && !loading && (
						<div className='flex w-full flex-grow  items-center justify-center'>
							{' '}
							<p className='text-center text-[14px] font-medium leading-5 text-mudPurple'>
								This list is empty right now.
								<br /> Consider adding new tips...
							</p>{' '}
						</div>
					)}
					{!loading && (
						<div>
							<InfiniteScroll
								dataLength={tips.length}
								next={() => {
									setResultsNum(tips.length);
								}}
								hasMore={hasMore}
								scrollableTarget='scroll-inf-task'
								inverse={false}
								loader={undefined}
							>
								{tips.map((item: any, index: number) => (
									<TipButton tip={item} setCreateTipModal={setCreateTipModal} setSelectedTip={setSelectedTip} key={item.id} setModalIsOpen={setModalIsOpen} setPracticeForDelete={setPracticeForDelete} />
								))}
							</InfiniteScroll>
						</div>
					)}
					{(loading || loadingMore) && (
						<div className='flex w-full flex-grow items-center justify-center'>
							<Loading size={70} primaryColor='#5E639B' stroke={3} />
						</div>
					)}
				</div>
			</div>
			<ConfirmationModal modalIsOpen={modalIsOpen} closeModal={closeModal} confirmation={deleteTip} message={'Do you want to delete this practice?'} subMessage='The practice will be permanently deleted.' />
			<CreateEditTipModal modalIsOpen={createTipModal} closeModal={closeCreateTipModal} tip={selectedTip} reloadTips={reloadTips} />
		</div>
	);
}

export default QuickTipsHome;

const TipButton = ({ tip, setSelectedTip, setCreateTipModal, setPracticeForDelete, setModalIsOpen }: { tip: any; setSelectedTip: any; setCreateTipModal: any; setPracticeForDelete: any; setModalIsOpen: any }) => {
	return (
		<div
			className='my-[5px] flex cursor-pointer flex-row gap-5 rounded-[10px] border border-[#F8F8FB] bg-[#F8F8FB] px-[40px] py-[25px] duration-300 ease-out hover:border-mudPurple'
			onClick={() => {
				setSelectedTip(tip);
				setCreateTipModal(true);
			}}
			key={tip.id}
		>
			<div className='flex flex-1 flex-col justify-center'>
				<h3 className='text-[20px] font-semibold leading-7 text-primaryViolet'>{tip.title}</h3>
				<div className='mt-[8px]'>
					<MDEditor.Markdown className='bg-containerGray' style={{ color: '#5E639B', backgroundColor: 'rgb(248 248 251)' }} source={tip.body} />
				</div>
			</div>
			<div className='flex shrink-0 items-center justify-center'>
				<div
					className='flex h-10 min-w-10 items-center justify-center rounded-full hover:bg-greyLight'
					onClick={(e) => {
						e.stopPropagation();
						setPracticeForDelete(tip.id);
						setModalIsOpen(true);
					}}
				>
					<DeleteIcon style={{ color: '#5E639B' }} />
				</div>
			</div>
		</div>
	);
};
